import tr from "./locales/tr";
import en from "./locales/en";
import { ModuleManager } from "@module-system";
import { availableLocales, ecvI18N } from "@module-system/i18n";

const i18n = ecvI18N(0);

i18n.global.te = (key, locale) => {
  const effectiveLocale = locale && locale.length ? locale : i18n.global.locale;
  const messages = i18n.global.messages[effectiveLocale];
  return Object.hasOwn(messages, key);
};

const originalT = i18n.global.t;
i18n.global.t = (key, locale, ...args) => {
  // first check te function
  if (!i18n.global.te(key, locale)) {
    return key;
  }
  return originalT(key, locale, ...args);
};

ModuleManager.addLocales({ tr, en }, "Web.App");
export default i18n;

export { availableLocales };
